module.exports = __webpack_public_path__ + "img/1585847207332432207.720e5252.png";